export const isProjectUrlValid = (projectName: string) => {
  const projUrl = projectName.trim();
  // URL syntax is complicated and not easy to represent in regex. So if it starts with https and it's free of spaces and double-quotes, it's probably good enough.
  return projUrl.length > 0 && projUrl.match(/^(https):\/\/[^ "]+$/);
};
